export default __webpack_public_path__ + "static/media/WorkSans-ExtraLight.4a4688e5.ttf";